module.exports = __webpack_public_path__ + "img/switchblur.337a3e71.jpg";